const baseUrl = ''
const timeout = 10000

export {
    baseUrl,
    timeout
}